import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'

export default function FAQ() {
    return (
        <div className="py-16 mx-auto w-full px-4 max-w-4xl">
            <h3 className="mb-12 text-4xl text-center leading-8 font-semibold tracking-tight text-gray-900 sm:text-4xl sm-leading-1o">Frequntly asked questions</h3>
            <div>
                <QA
                    question='What advantages does joining Career Hikers provide a Counselor or Q/A solver?'
                    answer="Any counsellor or question-and-answer provider who joins our Career Hikers platform will receive both
                financial and non-financial rewards. The counsellor or Q/A solver will also receive a Letter of
                Recommendation from Career Hikers in addition to these advantages, which will aid them in their
                placements cell. Additionally, you may alter many kid's futures by serving as a counsellor or question answer provider."
                />
                <QA
                    question='Any chance of PPO from the Career Hikers?'
                    answer='Yes, there is a possibility that our company will provide PPO. Your efforts will determine everything. Since we area developing business, opportunity may knock on your door at any time.
                '
                />
                <QA
                    question='What are the non-Monetary benefits?'
                    answer='
                Some of the Non- Monetary Benefits are:
                Development of People Management Skills                
                Improvement in persuasion abilities
                Improvement of leadership abilities
                Improved counselling abilities
                Opportunity for pre-placement with Career Hikers
                Can be used as an opportunity for an internship
                Improvement in the psychological knowledge of students
                Improvement of creative abilities'
                />
                <QA
                    question='How secure is my privacy on the Career Hikers platform?'
                    answer="You need not be concerned about anything compromising your privacy because it
                is our fundamental principle to respect each individual's private information. Your private
                information is only used by the company and is not disclosed to anyone else. Be
                careful not to give out your contact information on the Filo call and never request it
                from pupils."
                />
            </div>

        </div>
    )
}

function QA(props) {
    const [expand, setExpand] = useState(false);
    const expandClass = expand ? 'display' : 'hidden';
    const ansClass = `${expandClass} p-4`

    return (
        <div className='shadow rounded border border-gray-100 border-t-0 bg-green-50'>
            <div className='p-4 text-xl relative font-medium'>
                <div className='w-6/6'>
                    <p className='text-blue-900'>{props.question}</p>
                </div>
                <button
                    aria-label='question-expander'
                    className='text-xl absolute top-0 right-0 p-4 fous:outline-none bg-green-400'
                    onClick={() => setExpand(!expand)}
                    >
                    {expand ?
                        <FontAwesomeIcon icon={faChevronUp} className='w-5' />
                        :
                        <FontAwesomeIcon icon={faChevronDown} className='w-5' />
                    }
                </button>
            </div>
            <div className={ansClass}>
                <p className='text-sky-800'>
                    {props.answer}
                </p>
            </div>
        </div>
    )
}




